module.exports = __webpack_public_path__ + "static/img/joinus@2x.34f209f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/contactInfo/joinus@2x.png
// module id = Y1vL
// module chunks = 0